import type { ProjectsResponse } from '../../../../../api/projects-client/projects-client.type';
import { showTeamRelatedTasks } from '../../../../../store/strategy-store/strategy-store.actions';
import { useCostTeams } from '../cost-tab.hooks';
import { SideSectionOther } from './side-section-other';

export const SideSectionOtherTeams = () => {
  return (
    <SideSectionOther<ProjectsResponse>
      useData={useCostTeams}
      dataKey="otherTeamsData"
      showRelatedTasks={showTeamRelatedTasks}
      getDisplayName={(team) => team.name}
      getItemId={(team) => team.id}
      paramKey="team"
    />
  );
};
